import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { PfuLogo } from "../components/Logo";
import { useAuth } from "../auth";
import { apiError } from "../api";
import { Spinner } from "../components/ui";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signup(name, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md fade-in">
        <div className="flex items-center gap-2.5 mb-6">
          <PfuLogo size={40} />
          <div className="font-display font-bold text-xl text-ink">PFU Tracker</div>
        </div>

        <form onSubmit={submit} className="card p-6 space-y-4" data-testid="signup-form">
          <h1 className="font-display text-2xl text-ink">Create your account</h1>
          <p className="text-sm text-muted -mt-2">Start with a <strong className="text-teal">30-day free trial</strong>. No card required — subscribe only when it ends.</p>
          <div>
            <label className="label" htmlFor="name">Full name</label>
            <input id="name" required className="input" value={name}
              onChange={(e) => setName(e.target.value)} data-testid="signup-name" placeholder="Your name" />
          </div>
          <div>
            <label className="label" htmlFor="email">Email</label>
            <input id="email" type="email" required className="input" value={email}
              onChange={(e) => setEmail(e.target.value)} data-testid="signup-email"
              autoComplete="email" placeholder="you@example.com" />
          </div>
          <div>
            <label className="label" htmlFor="password">Password</label>
            <input id="password" type="password" required minLength={6} className="input" value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="signup-password"
              autoComplete="new-password" placeholder="At least 6 characters" />
          </div>
          {error && <p className="text-sm text-rose" data-testid="signup-error">{error}</p>}
          <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="signup-submit">
            {loading && <Spinner />} Create account
          </button>
        </form>

        <p className="text-sm text-muted text-center mt-5">
          Already registered?{" "}
          <Link to="/login" className="text-teal font-medium" data-testid="link-login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
